import { useEffect } from 'react'
import TinyMce from './TinyMce'

export default function Page({ page }: any) {
    useEffect(() => {
        const contest = page?.fields
        if (contest) {
            const divContest = document.getElementById(`content-${page.sys.id}`)
            if (divContest && contest.promotionScript) {
                divContest.appendChild(document.createRange().createContextualFragment(contest.promotionScript))
            }
        }

    }, [page])

    if (!page) return { notFound: true }

    return (
        <>
            <header>
                {
                    page.fields.hasOwnProperty('banner') ?
                        <div className='w-full flex flex-column overflow-hidden h-[300px]'>
                            <div className='bg-repeat-x bg-contain bg-center w-[100%]'
                                 style={{ backgroundImage: `url(${page.fields.banner.fields.file.url})` }}
                                 data-ll-status='loaded'>
                            </div>
                        </div>
                        : null
                }
                <h1 className='font-[Judge] m-auto text-center xl:w-[50%] lg:w-[60%] md:w-[70%] sm:w-[80%] w-[80%] py-12 text-uppercase transition-all duration-1000 has-text-align-center clear-both block mx-auto text-content'>
                    {page.fields.title}
                </h1>
            </header>
            <main id='main' className='m-auto xl:w-[50%] lg:w-[60%] md:w-[70%] sm:w-[80%] w-[80%] pb-24'>
                <div className='w-full'>
                    <section className='text-content font-[Oskari]'>
                        <TinyMce content={page.fields.content} />
                        {
                            page.fields?.promotionScript !== null && (
                                <>
                                    <hr className='w-full border-2 border-content mb-6' />
                                    <div id={`content-${page.sys.id}`} className='pb-6'>
                                    </div>
                                </>
                            )
                        }
                    </section>
                </div>
            </main>
        </>
    )
}
